import { ForwardToInboxOutlined, HowToRegOutlined, CheckBoxOutlineBlank } from '@mui/icons-material';
import { Checkbox, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ContributorInvitationCheckbox = ({
  isInvited,
  isAccepted,
  isSelected,
  onSelect,
  contributorEmail,
  isDisabled,
}: {
  isInvited: boolean;
  isAccepted: boolean;
  isSelected: boolean;
  onSelect: (selected: boolean) => void;
  contributorEmail?: string;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation();

  if (isAccepted) {
    return (
      <Tooltip title={t('contributor.invitationStatus.accepted')}>
        <HowToRegOutlined color="success" />
      </Tooltip>
    );
  }

  if (isInvited) {
    return (
      <Tooltip title={t('contributor.invitationStatus.invited')}>
        <ForwardToInboxOutlined color="info" />
      </Tooltip>
    );
  } else {
    if (!contributorEmail) {
      return (
        <Tooltip title={t('contributor.addEmailAddressTooltip')}>
          <CheckBoxOutlineBlank color="disabled" />
        </Tooltip>
      );
    }
    return (
      <Checkbox
        disableRipple
        color="primary"
        checked={isSelected}
        disabled={isDisabled}
        onChange={(event) => onSelect(event.target.checked)}
        sx={{ p: 0 }}
      />
    );
  }

  return null;
};
